import { render, staticRenderFns } from "./InvoiceDetailsDialog.vue?vue&type=template&id=3dc133a1&scoped=true"
import script from "./InvoiceDetailsDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDetailsDialog.vue?vue&type=style&index=0&id=3dc133a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc133a1",
  null
  
)

export default component.exports